import { useAuth0 } from '@auth0/auth0-react';

import { createSocketIo } from './api';

export function useAuth0SocketIo(authHeaders: Record<string, string>) {
  const { getAccessTokenSilently } = useAuth0();
  return createSocketIo(authHeaders, getAccessTokenSilently);
}
